import "./hooks/index"; // <-- Needs to be first
import Vue from "vue";
import App from "./app/app.vue";
import router from "./router";
import { store, MatIcon, fmtMsg } from "commonui";
import { NoVersionGroupAlert } from "@/components/no-version-group-alert";
import { setLicenseKey } from "wijmo/wijmo";
import * as GC from "@grapecity/spread-sheets";
import * as ExcelIO from "@grapecity/spread-excelio";
import i18n from "./commonui/locales/i18n";
import { Row, Col, message, Modal, Tooltip } from "ant-design-vue";
import VirtualScroller, { RecycleScroller as VirtualScrollerComponent } from "vue-virtual-scroller";
import { Action, ActionItem } from "commonui";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "./style/common.less";

Vue.config.productionTip = false;

setLicenseKey(
	"*.grapecity.net|*.grapecitydev.com|*.grapeseed.app|*.grapeseed.com|*.grapeseed.ru|*.grapeseed.us,483555874441165#B0ZNtgDNiojIklkIs4XXbpjInxmZiwiIxYXNyAjMiojIyVmdiwSZzxWYmpjIyNHZisnOiwmbBJye0ICRiwiI34TUZJzL7MUOUpHNGRmav5Eb5Jka8E7bZRHdYVVaOlkNmNUOxIlN4Vzb85mb5U7QlFGV5l5KyhXUGNXO6E6Y5EmTvNFeihFdEV6czQGWBtGT9k4SWtGR6gFU9MENT5mUI9UMIZEbNpWZ9NWSPxWRjZ5ZzVEVIdVc5N6ZVlndJVEZ8gEVFx6buFDakx4SmFVTKhXOipVWk3GVVZUaTZDWvolevokbHJTQ52CZBhTZlV5NxlVUX5mWv2kc6tESQdjR6sCVB5GdMp4ZptkSGNTTGhzawI4QVpFRlJEeqV5NHdDWI3GNIdHcLlnU9cDVONlTVtGbSFnNC3WYzkmTxdXTXN5bCB7dBlnTzE6a5JmbRdTTw5GaFZEMCpWc8klewJVQ5pGeUhld9Inb5gFdZlldolkUSZkSEx4KyYENnV5UzMnTPZUMQVTc6wEd8J5aFZmMjFUdrkjYr4kI0IyUiwiIFZEM7QkRERjI0ICSiwiM9YDM5kzNzcTM0IicfJye#4Xfd5nIJBjMSJiOiMkIsIibvl6cuVGd8VEIgQXZlh6U8VGbGBybtpWaXJiOi8kI1xSfiUTSOFlI0IyQiwiIu3Waz9WZ4hXRgAicldXZpZFdy3GclJFIv5mapdlI0IiTisHL3JyS7gDSiojIDJCLi86bpNnblRHeFBCI73mUpRHb55EIv5mapdlI0IiTisHL3JCNGZDRiojIDJCLi86bpNnblRHeFBCIQFETPBCIv5mapdlI0IiTisHL3JyMDBjQiojIDJCLiUmcvNEIv5mapdlI0IiTisHL3JSV8cTQiojIDJCLi86bpNnblRHeFBCI4JXYoNEbhl6YuFmbpZEIv5mapdlI0IiTis7W0ICZyBlIsISNycTN8ADI4IjMwYjMwIjI0ICdyNkIsIyc59CZlV6clBXYydmLqwSdy9CZlV6clBXYydmLqwSbvNmLkVWZzVGchJ7ZuoCLwBXYuQWZlNXZwFmcn9iKs46bj9idlRWe4l6YlBXYydmLqwCdl9mL9RXajVGchJ7ZuoiI0IyctRkIsICZ4xEIhlGZl5EIEVURTVGchJ7RiojIh94QiwiI5YTMxQDN4c2OdU"
);

GC.Spread.Sheets.LicenseKey = (ExcelIO as any).LicenseKey =
	"*.grapeseed.com|*.grapecitydev.com,233379477369894#B0eZTRyI4TrIGNmZmW92WRsdUYUpHWUp7LuNnUWpFO8REWJpVWhdnbvcnVwNmQ5FWNH9EO4FkVmhTMDp4T0V6d9FESVJVY7Nlc4ZnZ5lkUwNXaXdGVjd5KiF7L0NUdq5kTvhjayhXOohVbuNVY42UVuNDU6NWWJhGSJB7S8ADcDhHc7F4b4EkWLlkc6cWO7cDSidDTodmW9QmalVUO7RVWyI6RsdEUkxUVWJTVTVGTJhFcmZFOENnYDpFTVVUVmtCba3EWGdHMyhmcClWSiRTSu5UVsl4K7FEMzI6ZTZHWv94LUVkV82UWzoXcX3yRqBVR9FXOFF5YvUmI0IyUiwiI6YTOxEDOCdjI0ICSiwiNwUzM4YDNykTM0IicfJye35XX3JSRFlkViojIDJCLiQTMuYHIgMlSgQWYlJHcTJiOi8kI1tlOiQmcQJCLicjM4UTMwASMzMDMxIDMyIiOiQncDJCLi46bj9idlRWe4l6YlBXYydmLqwSbvNmLkVWZzVGchJ7ZuoiI0IyctRkIsICZ4xEIhlGZl5EIEVURTVGchJ7RiojIh94QiwiI4kDO9YzM7cDN9czMzMjMiojIklkIs4XZzxWYmpjIyNHZisnOiwmbBJye0ICRiwiI34zdGJlcXxmQVl4YplESHdlcCd4UlhXdSRVNqlmUulWRSJXSy3UNwkGc5hXcqxkZal4drZGTzdWT6MVd6hnUrQnR5YjVr5kWiZkaaRFbPFHU7p6Zy4kRvFnb0BlRNAWV";

// Global Component Registration
Vue.component("MatIcon", MatIcon);
Vue.component("Row", Row);
Vue.component("Col", Col);
Vue.component("Action", Action);
Vue.component("ActionItem", ActionItem);
Vue.component("Col", Col);
Vue.component("Tooltip", Tooltip);
Vue.component("NoVersionGroupAlert", NoVersionGroupAlert);

Vue.use(VirtualScroller, VirtualScrollerComponent);

Vue.prototype.$format = fmtMsg;

Vue.prototype.$message = message;
Vue.prototype.$confirm = Modal.confirm;

Vue.directive("click-outside", {
	bind: function (el: any, binding, vnode: any) {
		el.clickOutsideEvent = function (event) {
			// here I check that click was outside the el and his children
			if (!(el == event.target || el.contains(event.target))) {
				// and if it did, call method provided in attribute value
				vnode.context[binding.expression](event);
			}
		};
		document.body.addEventListener("click", el.clickOutsideEvent);
	},
	unbind: function (el: any) {
		document.body.removeEventListener("click", el.clickOutsideEvent);
	}
});

new Vue({
	router,
	store,
	i18n,
	render: (h) => h(App)
}).$mount("#app");
